import { useEffect, useState } from 'react';

let cachedFlags = null;
let inflight = null;

const fetchFlags = () => {
  if (!inflight) {
    inflight = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/config/features`)
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}));
  }
  return inflight;
};

// Runtime feature flags from the backend — toggling ENABLE_SECURE_LEAD_PIPELINE
// on the server flips the UI without a frontend rebuild.
export const useFeatureFlags = () => {
  const [flags, setFlags] = useState(cachedFlags);

  useEffect(() => {
    if (cachedFlags) return;
    let alive = true;
    fetchFlags().then((data) => {
      cachedFlags = data || {};
      if (alive) setFlags(cachedFlags);
    });
    return () => { alive = false; };
  }, []);

  return { flags: flags || {}, loaded: Boolean(flags) };
};
